// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShopQuests_container__2xjDb {
  padding-top: 140px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  position: relative;
  width: 100%;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_back__nB5mF {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #ead40c;
  cursor: pointer;
  display: flex;
  gap: 16px;
  margin-bottom: 78px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_title__kefqk {
  font-weight: 500;
  font-size: 36px;
  text-transform: uppercase;
  font-family: "DrukWideCyr_medium";
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_title__kefqk .ShopQuests_yellow__gGzp5 {
  color: #ead40c;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_info__znL\\+c {
  line-height: 115%;
  margin-top: 24px;
  width: 85%;
  font-weight: 400;
  font-size: 20px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_info__znL\\+c .ShopQuests_txt__AmSs6 {
  margin-top: 8px;
  font-weight: 400;
  font-size: 20px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_btn__2MdZK {
  display: block;
  margin-top: 24px;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_btn__2MdZK button {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  background-color: #fd4c0a;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  width: 111px;
  height: 46px;
  padding: 0 22px;
  transition: background-color 0.3s;
}
.ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_pic__Lx5YG {
  width: auto;
  height: 100%;
  max-width: 50%;
  object-fit: cover;
}

@media (max-width: 850px) {
  .ShopQuests_container__2xjDb {
    padding-top: 104px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_back__nB5mF {
    margin-bottom: 24px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_title__kefqk {
    font-size: 24px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_info__znL\\+c {
    font-size: 16px;
    width: 100%;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_pic__Lx5YG {
    width: auto;
    height: 100%;
    max-width: 100%;
    object-fit: cover;
    margin-top: 40px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_btn__2MdZK {
    width: 111px;
    height: 46px;
  }
  .ShopQuests_container__2xjDb .ShopQuests_wrapper__M90n9 .ShopQuests_btn__2MdZK button {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/ShopQuests/ShopQuests.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;AAGE;ECsCA,eAAA;EACA,gBAAA;EACA,kBAAA;EDrCE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AAEI;ECgCF,eAAA;EACA,gBAAA;EACA,kBAAA;ED/BI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AACN;AAEI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iCAAA;AAAN;AAEM;EACE,cAAA;AAAR;AAII;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAFN;AAIM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAFR;AAMI;EACE,cAAA;EACA,gBAAA;AAJN;AAMM;ECRJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDSM,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAHR;AAWI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AATN;;AAcA;EACE;IACE,kBAAA;EAXF;EAaE;IACE,WAAA;IACA,sBAAA;IACA,uBAAA;EAXJ;EAaI;IACE,mBAAA;EAXN;EAcI;IACE,eAAA;EAZN;EAeI;IACE,eAAA;IACA,WAAA;EAbN;EAgBI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EAdN;EAiBI;IACE,YAAA;IACA,YAAA;EAfN;EAgBM;IACE,WAAA;IACA,uBAAA;EAdR;AACF","sourcesContent":["@import \"../../../assets/styles/global.scss\";\n\n.container {\n  padding-top: 140px;\n\n  .wrapper {\n    @include subtitle5;\n\n    color: #e0e0e0;\n    position: relative;\n    width: 100%;\n    z-index: 2;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    .back {\n      @include subtitle6m;\n\n      align-items: center;\n      color: #ead40c;\n      cursor: pointer;\n      display: flex;\n      gap: 16px;\n      margin-bottom: 78px;\n    }\n\n    .title {\n      font-weight: 500;\n      font-size: 36px;\n      text-transform: uppercase;\n      font-family: \"DrukWideCyr_medium\";\n\n      .yellow {\n        color: #ead40c;\n      }\n    }\n\n    .info {\n      line-height: 115%;\n      margin-top: 24px;\n      width: 85%;\n      font-weight: 400;\n      font-size: 20px;\n\n      .txt {\n        margin-top: 8px;\n        font-weight: 400;\n        font-size: 20px;\n      }\n    }\n\n    .btn {\n      display: block;\n      margin-top: 24px;\n\n      button {\n        @include subtitle6m;\n\n        align-items: center;\n        background-color: #fd4c0a;\n        border-radius: 8px;\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        width: 111px;\n        height: 46px;\n        padding: 0 22px;\n        transition: background-color 0.3s;\n\n        // &:hover {\n        //   background-color: darken(#ead40c, 10%);\n        // }\n      }\n    }\n\n    .pic {\n      width: auto;\n      height: 100%;\n      max-width: 50%;\n      object-fit: cover;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 104px;\n\n    .wrapper {\n      width: 100%;\n      flex-direction: column;\n      align-items: flex-start;\n\n      .back {\n        margin-bottom: 24px;\n      }\n\n      .title {\n        font-size: 24px;\n      }\n\n      .info {\n        font-size: 16px;\n        width: 100%;\n      }\n\n      .pic {\n        width: auto;\n        height: 100%;\n        max-width: 100%;\n        object-fit: cover;\n        margin-top: 40px;\n      }\n\n      .btn {\n        width: 111px;\n        height: 46px;\n        button {\n          width: 100%;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShopQuests_container__2xjDb`,
	"wrapper": `ShopQuests_wrapper__M90n9`,
	"back": `ShopQuests_back__nB5mF`,
	"title": `ShopQuests_title__kefqk`,
	"yellow": `ShopQuests_yellow__gGzp5`,
	"info": `ShopQuests_info__znL+c`,
	"txt": `ShopQuests_txt__AmSs6`,
	"btn": `ShopQuests_btn__2MdZK`,
	"pic": `ShopQuests_pic__Lx5YG`
};
export default ___CSS_LOADER_EXPORT___;
